import axios from 'axios';
import api from './endpoints';

export default {
    typeList() {
        return axios.get(api.VOLUNTEER_TYPES).then((result) => result.data);
    },
};
